import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { compareAsc, format, addMonths } from "date-fns";
import moment from "moment";
function ViewEmployeeCom() {
  const [searchParams, setSearchParams] = useSearchParams("");
  const id = searchParams.get("id");
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem("key"));

  const [email, setEmail] = useState("");
  const [reportingmanager, setreportingmanager] = useState("");
  const [finalreporting, setFinalreporting] = useState("");
  const [joiningdate, setJoiningdate] = useState("");
  const [confirmationdate, setConfirmationdate] = useState("");
  const [contactnumber, setContactnumber] = useState("");
  const [name, setName] = useState("");
  const [usercode, setUsercode] = useState("");
  const [role, setRole] = useState("");
  const [deptName, setDeptName] = useState("");
  const [location, setLocation] = useState("");
  const [worklocations, setWorklocation] = useState(["", "NOIDA"]);
  const [company, setCompany] = useState("");
  const [user_type, setUser_type] = useState("");
  const [system_role, setSystem_role] = useState("");
  const [salutation, setSalutation] = useState("");

  const [fname, setFname] = useState("");
  const [mname, setMname] = useState("");
  const [lname, setLname] = useState("");
  const [personalemail, setPersonalemail] = useState();
  const [altemail, setAltemail] = useState();
  const [guardian_name, setGuardian_name] = useState();
  const [gender, setGender] = useState("");
  const [dob, setDob] = useState("");
  const [wedding_day, setWedding_day] = useState("");
  const [bloodgroup, setBloodgroup] = useState("");
  const [hobbies, setHobbies] = useState("");
  const [weight, setWeight] = useState("");
  const [height, setHeight] = useState("");
  const [nationality, setNationality] = useState("");
  const [adhaarnumber, setAdhaarnumber] = useState("");
  const [aadharcardfile, setAadharcardfile] = useState("");
  const [pannumber, setPannumber] = useState("");
  const [pancard, setPancard] = useState("");
  const [profile, setProfile] = useState("");
  const [addressProof, setAddressProof] = useState("");
  const [timezone, setTimeZone] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [shift, setShift] = useState("");
  const [emercontactpersion, setEmercontactpersion] = useState("");
  const [emercontactnumber, setEmercontactnumber] = useState("");
  const [emercontactrelation, setEmercontactrelation] = useState("");
  const [currenAdd, setcurrenAdd] = useState("");
  const [permanentaddress, setPermanentaddress] = useState("");

  const [empslip1, setEmpslip1] = useState("");
  const [empslip2, setEmpslip2] = useState("");
  const [empslip3, setEmpslip3] = useState("");

  const [ctc, setCtc] = useState("");
  const [salaryType, setSalaryType] = useState("");
  const [bankname, setBankname] = useState("");
  const [accountnumber, setAccountnumber] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [uan_number, setUan_number] = useState("");
  const [pfnumber, setPfnumber] = useState("");
  const [pfgroup, setPfgroup] = useState("");

  const [speak1, setSpeak1] = useState("");
  const [speak2, setSpeak2] = useState("");
  const [write1, setWrite1] = useState("");
  const [write2, setWrite2] = useState("");
  const [read1, setRead1] = useState("");
  const [read2, setRead2] = useState("");
  const [understand1, setUnderstand1] = useState("");
  const [understand2, setUnderstand2] = useState("");
  const [language1, setLanguage1] = useState("");
  const [language2, setLanguage2] = useState("");

  const [computerSkills, setComputerSkills] = useState("");
  const [otherSkills, setOtherSkills] = useState("");
  const [empstatus, setEmpstatus] = useState("");
  const [dateofjoining, setDateofjoining] = useState("");

  const [empExp, setEmpExp] = useState([]);
  const [marriage, setMarriage] = useState("");

  const [uploadpassport, setUploadpassport] = useState("");
  const [uploadpancard, setUploadpancard] = useState("");
  useEffect(() => {
    getuserdetailsById(id);
  }, []);
  const getuserdetailsById = async () => {
    try {
      const response = await fetch(
        `${SERVER_URL}api/employee/getuserdetailsbyid`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            authorization: `Bearer ${token.value}`,
          },
          body: JSON.stringify({ id }),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      if (data.status == true) {
        setEmail(data?.result?.email);
        setFinalreporting(data?.result?.fnl_reporting);
        setreportingmanager(data?.result.reportingmanager);

        setJoiningdate(data?.result?.joining_date);
        setContactnumber(data?.result?.contact_no);
        setName(data?.result?.name);
        setUsercode(data?.result?.user_code);
        setRole(data?.result?.role_name);
        setDeptName(data?.result?.dept_name);
        setLocation(data?.result?.location);
        setCompany(data?.result?.company);
        setUser_type(data?.result?.user_type);
        setSystem_role(data?.result?.system_role);
        setSalutation(data?.result?.salutation);
        setFname(data?.result?.fname);
        setMname(data?.result?.mname);
        setLname(data?.result?.lname);
        setPersonalemail(data?.result?.personal_email);
        setAltemail(data?.result?.alt_email);
        setGuardian_name(data?.result?.guardian_name);
        setGender(data?.result?.gender);
        setDob(data?.result?.dob);
        setWedding_day(data?.result?.wedding_day);
        setBloodgroup(data?.result?.blood_group);
        setHobbies(data?.result?.hobbies);
        setWeight(data?.result?.Weight);
        setHeight(data?.result?.Height);
        setTimeZone(data?.result?.timezonename + "-" + data?.result?.timezone);
        setNationality(data?.result?.nationality_type);
        setUploadpassport(data?.result?.Passportno);
        setUploadpancard(data?.result?.Filepancard);
        // if (
        //   data?.result?.time_zone == 1 ||
        //   data?.result?.time_zone == 3 ||
        //   data?.result?.time_zone == 4 ||
        //   data?.result?.time_zone == 6 ||
        //   data?.result?.time_zone == 7 ||
        //   data?.result?.time_zone == 8
        // ) {
        //   setNationality("United States of America");
        // }
        // if (data?.result?.time_zone == 2) {
        //   setNationality("United Kingdom");
        // }
        setAdhaarnumber(data?.result?.uid_no);
        setAadharcardfile(data?.result?.AadharcardFiles);
        setPannumber(data?.result?.pan_no);
        setPancard(data?.result?.pan_card);
        setProfile(data?.result?.PassportSizePhoto);
        setAddressProof(data?.result?.AddressProof);
        setCountry(data?.result?.countryname);
        setState(data?.result?.statename);
        setShift(data?.result?.shift);

        setEmercontactpersion(data?.result?.emergencycontactperson);
        setEmercontactnumber(data?.result?.emergencyphonenumber);
        setEmercontactrelation(data?.result?.personrelation);
        setcurrenAdd(data?.result?.address);
        setPermanentaddress(data?.result?.permanent_add);
        setEmpslip1(data?.result?.slip1);
        setEmpslip2(data?.result?.slip2);
        setEmpslip3(data?.result?.slip3);

        setCtc(data?.result?.ctc);
        setSalaryType(data?.result?.salary_type);
        setBankname(data?.result?.bank_name);
        setAccountnumber(data?.result?.account_no);
        setIfsc(data?.result?.bank_ifsc);
        setPfnumber(data?.result?.pf_no);
        setPfgroup(data?.result?.pf_group);
        setUan_number(data?.result?.uan_number);

        setSpeak1(data?.result?.language1_SpeakP);
        setSpeak2(data?.result?.language2_SpeakP);
        setWrite1(data?.result?.language1_WriteP);
        setWrite2(data?.result?.language2_WriteP);
        setRead1(data?.result?.language1_ReadP);
        setRead2(data?.result?.language2_ReadP);
        setUnderstand1(data?.result?.understand1);
        setUnderstand2(data?.result?.understand2);
        setLanguage1(data?.result?.language1);
        setLanguage2(data?.result?.language2);

        setComputerSkills(data?.result?.computer_skills);
        setOtherSkills(data?.result?.other_skills);
        setEmpstatus(data?.result?.status);
        setDateofjoining(
          moment(data?.result?.joining_date).format("yyyy-MM-DD")
        );
        setConfirmationdate(
          moment(data?.result?.joining_date)
            .add(6, "months")
            .format("YYYY-MM-DD")
        );
        setMarriage(data?.result?.marrige_status);
      }
    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  useEffect(() => {
    previouscompempdetails();
  }, []);
  const previouscompempdetails = () => {
    const response = fetch(SERVER_URL + `api/employee/empprecompanydetails`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        setEmpExp(data.data);
      });
  };

  const [familymembername, setFamilymembername] = useState("");
  const [familymemberrelation, setFamilymemberrelation] = useState("");
  const [familymemberdob, setFamilymemberdob] = useState("");
  const [familymemberage, setFamilymemberage] = useState("");
  const [familymemberaccupation, setFamilymemberaccupation] = useState("");
  const [familymemberlist, setFamilymemberlist] = useState([]);
  useEffect(() => {
    getFamilyMembersDetails();
  }, []);
  const getFamilyMembersDetails = () => {
    const response = fetch(SERVER_URL + `api/employee/getEmpmemberdetails`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emp_id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setFamilymemberlist(data?.data);
          setFamilymembername("");
          setFamilymemberrelation("");
          setFamilymemberdob("");
          setFamilymemberage("");
          setFamilymemberaccupation("");
        }
      });
  };

  const [empqualificationlist, setEmpqualificationlist] = useState([]);
  useEffect(() => {
    getQualification();
  }, []);
  const getQualification = () => {
    const response = fetch(SERVER_URL + `api/employee/getEmpqualification`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        authorization: `bearer ${token.value}`,
      },
      body: JSON.stringify({
        emp_id: id,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status == true) {
          setEmpqualificationlist(data?.results);
        }
      });
  };

  return (
    <>
      <div className="page-header">
        <h1>View Employee</h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Employee List
            </Link>
          </li>
          <li className="current">
            <span>/</span>View Employee
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="user_details_wrp">
          <div className="row">
            <div className="col-md-5">
              <div className="profile_detail">
                <div className="pic_user_details">
                  <img src="assets/images/f_user.png" alt="" />
                </div>
                <div className="name_user_details">
                  <div className="pro_title mb05">
                    {name ? name : "N/A"} [{usercode ? usercode : "N/A"}]
                  </div>
                  <div className="pro_sub_head mb05">{role ? role : "N/A"}</div>
                  <div className="pro_sub_head mb05">
                    <i className="icon icon-apartment"></i>
                    {deptName ? deptName : "N/A"}
                  </div>
                  <div className="pro_sub_head">
                    <i className="icon icon-map-marker"></i>
                    {location ? worklocations[location] : "N/A"}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-7">
              <div className="row">
                <div className="col-md-6">
                  <div className="pro_blk pt10">
                    <div className="pro_heading">Phone Number</div>
                    <div className="pro_sub_head">
                      <i className="icon icon-telephone2 mr05"></i>
                      {contactnumber ? contactnumber : "N/A"}
                    </div>
                  </div>
                  <div className="pro_blk">
                    <div className="pro_heading">Email</div>
                    <div className="pro_sub_head">
                      <i className="icon icon-envelope mr05"></i>
                      {email}
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="pro_blk">
                    <div className="pro_heading">Date of Joining</div>
                    <div className="pro_sub_head">
                      <i className="icon icon-calendar-full mr05"></i>
                      {joiningdate
                        ? moment(joiningdate).format("DD MMMM, yyyy")
                        : "N/A"}
                    </div>
                  </div>
                  <div className="pro_blk">
                    <div className="pro_heading">Reporting Manager</div>
                    <div className="pro_sub_head">
                      {finalreporting ? finalreporting : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="profile_detail_wrp relative mt30">
          <div
            className="nav leftzero"
            id="profiletab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              className="nav-link active"
              id="employmentprofile-tab"
              data-bs-toggle="tab"
              href="#employmentprofile"
              data-bs-target="#employmentprofile"
            >
              Employment Profile
            </a>

            <a
              className="nav-link"
              id="empspc-tab"
              data-bs-toggle="tab"
              href="#empspc"
              data-bs-target="#empspc"
            >
              Employment Detail
            </a>
            <a
              className="nav-link"
              id="otherdetail-tab"
              data-bs-toggle="tab"
              href="#otherdetail"
              data-bs-target="#otherdetail"
            >
              Bank Detail
            </a>

            <a
              className="nav-link"
              id="empfamily-tab"
              data-bs-toggle="tab"
              href="#empfamily"
              data-bs-target="#empfamily"
            >
              Family & Qualification Detail
            </a>

            <a
              className="nav-link"
              id="empprevious-tab"
              data-bs-toggle="tab"
              href="#empprevious"
              data-bs-target="#empprevious"
            >
              Previous Employment Detail
            </a>
          </div>
          <div className="tab_content tab-content">
            <div
              className="tab-pane fade active show"
              id="employmentprofile"
              role="tabpanel"
              aria-labelledby="employmentprofile-tab"
            >
              <div className="row mb30">
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Company Name</div>
                    <div className="form-input fw-500">
                      {company ? company : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Division</div>
                    <div className="form-input fw-500">
                      {deptName ? deptName : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Department</div>
                    <div className="form-input fw-500">
                      {role ? role : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Employment Mode</div>
                    <div className="form-input fw-500">
                      {user_type == 1
                        ? "Payroll"
                        : user_type == 2
                        ? "Contract"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">System Role</div>
                    <div className="form-input fw-500">
                      {system_role ? system_role : "N/A"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab_sub_ttl">Basic Info</div>
              <div className="row mb30">
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Salutation </div>
                    <div className="form-input fw-500">
                      {salutation == 1
                        ? "Mr"
                        : salutation == 2
                        ? "Ms"
                        : salutation == 3
                        ? "Mrs"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">First Name</div>
                    <div className="form-input fw-500">
                      {fname ? fname : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Middle Name</div>
                    <div className="form-input fw-500">
                      {mname ? mname : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Last Name</div>
                    <div className="form-input fw-500">
                      {lname ? lname : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Personal Email</div>
                    <div className="form-input fw-500">
                      {personalemail ? personalemail : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Alternate Email</div>
                    <div className="form-input fw-500">
                      {altemail ? altemail : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Contact Number </div>
                    <div className="form-input fw-500">
                      {contactnumber ? contactnumber : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Father/Husband</div>
                    <div className="form-input fw-500">
                      {guardian_name ? guardian_name : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Gender</div>
                    <div className="form-input fw-500">
                      {gender == 1 ? "Male" : gender == 2 ? "Female" : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Date Of Birth</div>
                    <div className="form-input fw-500">
                      {dob ? moment(dob).format("DD MMMM, yyyy") : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Marital Status</div>
                    <div className="form-input fw-500">
                      {marriage == 1
                        ? "Married"
                        : marriage == 2
                        ? "Unmarried"
                        : marriage == 3
                        ? "Other"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                {marriage == 1 && (
                  <div className="col-md-4">
                    <div className="form-blk mb20">
                      <div className="form-label">Anniversary Date</div>
                      <div className="form-input fw-500">
                        {wedding_day
                          ? moment(wedding_day).format("DD MMMM, yyyy")
                          : "N/A"}
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Blood Group</div>
                    <div className="form-input fw-500">
                      {bloodgroup ? bloodgroup : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Hobbies</div>
                    <div className="form-input fw-500">
                      {hobbies ? hobbies : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Weight ( Kg ) </div>
                    <div className="form-input fw-500">
                      {weight ? weight : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Height ( inches ) </div>
                    <div className="form-input fw-500">
                      {height ? height : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Nationality</div>
                    <div className="form-input fw-500">
                      {nationality ? nationality : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Aadhaar Card Number</div>
                    <div className="form-input fw-500">
                      {adhaarnumber ? adhaarnumber : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">View Aadhaar Card</div>
                    <div className="form-input input-group">
                      {/* {aadharcardfile?aadharcardfile:'N/A'}  */}
                      {/* <a className="view_btn_icon icon icon-eye"></a> */}

                      {aadharcardfile ? (
                        <a
                          className="view_btn_icon icon icon-eye"
                          href={`${SERVER_URL}uploads/emp_proof/${aadharcardfile}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        ></a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Pan Card Number</div>
                    <div className="form-input fw-500">
                      {pannumber ? pannumber : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">View Pan Card</div>
                    <div className="form-input">
                      {uploadpancard ? (
                        <a
                          className="view_btn_icon icon icon-eye"
                          href={`${SERVER_URL}uploads/emp_proof/${uploadpancard}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        ></a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">
                      Photograph ( Passport size )
                    </div>
                    <div className="form-input">
                      {profile ? (
                        <a
                          className="view_btn_icon icon icon-eye"
                          href={`${SERVER_URL}uploads/emp_proof/${profile}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        ></a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Upload passport</div>
                    <div className="form-input">
                      {uploadpassport ? (
                        <a
                          className="view_btn_icon icon icon-eye"
                          href={`${SERVER_URL}uploads/emp_proof/${uploadpassport}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        ></a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">View Address Proof</div>
                    <div className="form-input">
                      {addressProof ? (
                        <a
                          className="view_btn_icon icon icon-eye"
                          href={`${SERVER_URL}uploads/emp_proof/${addressProof}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        ></a>
                      ) : (
                        "N/A"
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab_sub_ttl">Location</div>
              <div className="row mb30">
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Country </div>
                    <div className="form-input fw-500">
                      {country ? country : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Time Zone </div>
                    <div className="form-input fw-500">
                      {/* IST-UTC +05:30 (India) */}
                      {timezone}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">State </div>
                    <div className="form-input fw-500">
                      {state ? state : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Work Location </div>
                    <div className="form-input fw-500">
                      {location ? worklocations[location] : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Shift Time </div>
                    <div className="form-input fw-500">
                      {shift ? shift : "N/A"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab_sub_ttl">Emergency Contact</div>
              <div className="row mb30">
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Person </div>
                    <div className="form-input fw-500">
                      {emercontactpersion ? emercontactpersion : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Person Relationship</div>
                    <div className="form-input fw-500">
                      {emercontactrelation ? emercontactrelation : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Phone Number</div>
                    <div className="form-input fw-500">
                      {emercontactnumber ? emercontactnumber : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
              <div className="tab_sub_ttl">Address</div>
              <div className="row mb30">
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Current Address </div>
                    <div className="form-input fw-500">
                      {currenAdd ? currenAdd : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Permanent Address</div>
                    <div className="form-input fw-500">
                      {permanentaddress ? permanentaddress : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="tab-pane"
              id="empspc"
              role="tabpanel"
              aria-labelledby="empspc-tab"
            >
              <div className="tab_sub_ttl">Employee Detail</div>
              <div className="row mb30">
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Employee Code</div>
                    <div className="form-input fw-500">
                      {usercode ? usercode : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Employee Status</div>
                    <div className="form-input fw-500">
                      {empstatus == 1
                        ? "Active"
                        : empstatus == 2
                        ? "Inactive"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Date of joining</div>
                    <div className="form-input fw-500">
                      {joiningdate
                        ? moment(joiningdate).format("DD MMMM, yyyy")
                        : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Probation Period (Month)</div>
                    <div className="form-input fw-500">6</div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Confirmation Date</div>
                    <div className="form-input fw-500">
                      {/* {confirmationdate ? confirmationdate : "N/A"} */}

                      {confirmationdate
                        ? moment(confirmationdate).format("DD MMMM, yyyy")
                        : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Notice Period (Days) </div>
                    <div className="form-input fw-500">30</div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">First Reporting</div>
                    <div className="form-input fw-500">
                      {reportingmanager ? reportingmanager : "N/A"}
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Final Reporting</div>
                    <div className="form-input fw-500">
                      {finalreporting ? finalreporting : "N/A"}
                    </div>
                  </div>
                </div>

                {/* <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Last Working Day</div>
                    <div className="form-input fw-500">26 July, 2021</div>
                  </div>
                </div> */}
                {/* <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Remark</div>
                    <div className="form-input fw-500">test</div>
                  </div>
                </div> */}
              </div>

              <div className="tab_sub_ttl">Skill</div>
              <div className="row mb30">
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">Computer Skills</div>
                    <div className="form-input fw-500">
                      {computerSkills ? computerSkills : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-blk mb20">
                    <div className="form-label">
                      Other Skills / Certifications
                    </div>
                    <div className="form-input fw-500">
                      {otherSkills ? otherSkills : "N/A"}
                    </div>
                  </div>
                </div>
              </div>

              <div className="tab_sub_ttl">Languages</div>
              <table className="monthly_table mt20">
                <thead>
                  <tr>
                    <th></th>
                    <th>Speak</th>
                    <th>Read</th>
                    <th>Write</th>
                    <th>Understand</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>English</td>
                    <td>
                      {speak1 == 1
                        ? "Level I"
                        : speak1 == 2
                        ? "Level II"
                        : speak1 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                    <td>
                      {read1 == 1
                        ? "Level I"
                        : read1 == 2
                        ? "Level II"
                        : read1 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                    <td>
                      {write1 == 1
                        ? "Level I"
                        : write1 == 2
                        ? "Level II"
                        : write1 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                    <td>
                      {understand1 == 1
                        ? "Level I"
                        : understand1 == 2
                        ? "Level II"
                        : understand1 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td>Hindi</td>
                    <td>
                      {speak2 == 1
                        ? "Level I"
                        : speak2 == 2
                        ? "Level II"
                        : speak2 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                    <td>
                      {read2 == 1
                        ? "Level I"
                        : read2 == 2
                        ? "Level II"
                        : read2 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                    <td>
                      {write2 == 1
                        ? "Level I"
                        : write2 == 2
                        ? "Level II"
                        : write2 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                    <td>
                      {understand2 == 1
                        ? "Level I"
                        : understand2 == 2
                        ? "Level II"
                        : understand2 == 3
                        ? "Level III"
                        : "N/A"}
                    </td>
                  </tr>
                  <tr>
                    <td colSpan="4" className="green_mgs">
                      Note : Level I - Limited Knowledge , Level II - Good
                      Working Knowledge , Level III - Expertise
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              className="tab-pane"
              id="otherdetail"
              role="tabpanel"
              aria-labelledby="otherdetail-tab"
            >
              <div className="tab_sub_ttl">Organization</div>
              <div className="row mb30">
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Salary Type</div>
                    <div className="form-input fw-500">
                      {salaryType == 1
                        ? "Monthly Basis"
                        : salaryType == 2
                        ? "Daily Basis"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">CTC</div>
                    <div className="form-input fw-500">{ctc ? ctc : "N/A"}</div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Salary Bank</div>
                    <div className="form-input fw-500">
                      {bankname == 1
                        ? "HDFC Bank"
                        : bankname == 2
                        ? "Federal Bank"
                        : bankname == 3
                        ? "IDFC FIRST Bank"
                        : bankname == 4
                        ? "RBL Bank"
                        : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">Account Number</div>
                    <div className="form-input fw-500">
                      {accountnumber ? accountnumber : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">IFSC Code</div>
                    <div className="form-input fw-500">
                      {ifsc ? ifsc : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">PF Number</div>
                    <div className="form-input fw-500">
                      {pfnumber ? pfnumber : "N/A"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">PF Group</div>
                    <div className="form-input fw-500">
                      {pfgroup == 1 ? "Yes" : "No"}
                    </div>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="form-blk mb20">
                    <div className="form-label">UAN Number</div>
                    <div className="form-input fw-500">
                      {uan_number ? uan_number : "N/A"}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="tab-pane"
              id="empfamily"
              role="tabpanel"
              aria-labelledby="empfamily-tab"
            >
              <div className="tab_sub_ttl">Family Detail</div>
              <table className="monthly_table mt20 mb30">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Relationship</th>
                    <th>Age </th>
                    <th>Date of Birth</th>
                    <th>Occupation</th>
                  </tr>
                </thead>
                <tbody>
                  {familymemberlist?.map((item, ind) => (
                    <tr key={ind}>
                      <td>{item.name}</td>
                      <td>{item.relation}</td>
                      <td>{item.age}</td>
                      <td>
                        {item.dob
                          ? moment(item.dob).format("DD MMMM, yyyy")
                          : "N/A"}
                      </td>
                      <td>{item.accupation}</td>
                      {/* <td className="text-right"> */}
                      {/* <button
                          className="btn_8 small_btn"
                          onClick={(e) => deletefamilymember(item.id)}
                        >
                          <i className="icon icon-cross"></i>
                        </button> */}
                      {/* </td> */}
                    </tr>
                  ))}

                  {(familymemberlist.length < 1 ||
                    familymemberlist.length == "" ||
                    familymemberlist.length == undefined) && (
                    <tr>
                      <td colSpan="6" className="text-center">
                        <div className="notfound">No Record found</div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <div className="tab_sub_ttl">Qualification Detail</div>
              <table className="monthly_table mt20 mb25">
                <thead>
                  <tr rowSpan="2">
                    <th>Educational Institutions Name</th>
                    <th>From Date</th>
                    <th>To Date</th>
                    <th>Degree / Diploma Major Subjects </th>
                    <th>Major Subjects</th>
                    <th className="text-right">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {empqualificationlist?.map((item, ind) => (
                    <tr key={ind}>
                      <td>{item.institute_name}</td>
                      <td>{item.fromYear}</td>
                      <td>{item.toYear}</td>
                      <td>{item.degree_name}</td>
                      <td>{item.subjects}</td>
                      <td className="text-right">
                        <a
                          className="btn_7 small_btn mr05"
                          href={`${SERVER_URL}uploads/emp_degree/${item.doc}`}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <i className="icon icon-eye"></i>
                        </a>
                        {/* <button
                          className="btn_8 small_btn"
                          onClick={() => removeQualification(item.id)}
                        >
                          <i className="icon icon-cross"></i>
                        </button> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div
              className="tab-pane"
              id="empprevious"
              role="tabpanel"
              aria-labelledby="empprevious-tab"
            >
              <div className="tab_sub_ttl">Previous Employment Detail</div>
              <table className="monthly_table mt20 mb25">
                <thead>
                  <tr rowSpan="2">
                    <th>Company Name</th>
                    <th>Title of Position</th>
                    <th>Name &amp; Phone No. of Supervisor</th>
                    <th>From &amp; Till Date</th>
                    <th>Total CTC including Benefits</th>
                    <th>Address of Employer</th>
                    <th>Reason for Leaving</th>
                    <th className="text-right" style={{ width: "150px" }}>
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {empExp?.length === 0 ? (
                    <tr>
                      <td colSpan="8" className="text-center">
                        No records added yet
                      </td>
                    </tr>
                  ) : (
                    empExp?.map((item, ind) => (
                      <tr key={ind}>
                        <td>{item.name}</td>
                        <td>{item.position}</td>
                        <td>
                          {item.nameOfSup} & {item.numberOfSup}
                        </td>
                        <td>
                          {item.fromdate} & {item.todate}
                        </td>
                        <td>{item.empctc}</td>
                        <td>{item.cmpadd}</td>
                        <td>{item.reasonleaving}</td>
                        <td className="text-right">
                          <a
                            className="small_btn btn_9 mr05"
                            href={`${SERVER_URL}uploads/previousCompantFiles/${item.appointment_letter}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            AL
                          </a>
                          <a
                            className="small_btn btn_7 mr05"
                            href={`${SERVER_URL}uploads/previousCompantFiles/${item.reliving_letter}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            RL
                          </a>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
              <div className="joining_blk">
                <div className="tab_sub_ttl">Previous Company Salary Slip</div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-blk">
                      <div className="form-label">Slip 1</div>
                      <div className="form-input input-group">
                        {/* <input
                          type="text"
                          className="form-control form-control1"
                          value=""
                          readOnly
                        /> */}
                        {empslip1 ? (
                          <a
                            className="btn_7"
                            href={`${SERVER_URL}uploads/slip/${empslip1}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye"></i>
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk">
                      <div className="form-label">Slip 2</div>
                      <div className="form-input input-group">
                        {/* <input
                          type="text"
                          className="form-control form-control1"
                          value=""
                          readOnly
                        /> */}
                        {empslip2 ? (
                          <a
                            className="btn_7"
                            href={`${SERVER_URL}uploads/slip/${empslip2}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye"></i>
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-blk">
                      <div className="form-label">Slip 3</div>
                      <div className="form-input input-group">
                        {empslip3 ? (
                          <a
                            className="btn_7"
                            href={`${SERVER_URL}uploads/slip/${empslip3}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <i className="icon icon-eye"></i>
                          </a>
                        ) : (
                          "N/A"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewEmployeeCom;
